import { compose, lifecycle, withProps } from 'recompose';
import { partial } from 'lodash';
import { connect } from 'react-redux';
import * as categoriesActions from './actions';
import { isFetched } from './selectors';
import { getShopBrandId, isBrandViewActive } from '../../../auth/selectors';

const mapStateToProps = state => ({
  shop: state.auth.shop,
  barberUser: state.auth.barberUser,
  isFetched: isFetched(state),
  brandId: getShopBrandId(state),
  isBrandUser: isBrandViewActive(state),
});

const mapDispatchToProps = {
  fetchCategories: categoriesActions.fetchAllItems,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(ownProps => ({ fetchCategories: partial(ownProps.fetchCategories, ownProps.brandId) })),
  lifecycle({
    componentDidMount() {
      if (this.props.isFetched) {
        return true;
      }

      return this.props.fetchCategories();
    },
  })
);

export default enhance;
